export const routeMap = {
  LOGIN: '/login',
  DASHBOARD: {
    ROOT: '/',
    INDEX: '/',
    ALERTS: '/alerts',
    MESSAGES: '/messages',
    TASKS: '/tasks',
    PROFILE: '/profile'
  }
}
